module.exports = __webpack_public_path__ + "img/164-5c9a07.png";